<template>
  <a
    class="items-center hidden px-1.5 xl:p-2 text-sm font-medium md:flex text-secondary-100"
    href="https://help.ahaslides.com/"
    target="_blank"
    v-tooltip="tooltipHelp"
    @click="trackGAHelpCenter"
  >
    <aha-icon
      class="mr-0 xl:mr-1"
      name="question"
      width="16"
      height="16"
      viewBox="0 0 24 24"
    />
    <span class="hidden xl:block">
      {{ $i18nPresenter.t('Help') }}
    </span>
  </a>
</template>

<script>
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

const iconOpenLink = require('@/assets/images/vector.svg')

export default {
  data: () => {
    return {
      tooltipHelp: {
        content: '',
      },
    }
  },
  mounted() {
    this.tooltipHelp.content = this.$i18nPresenter.t('ThisLinkOpensInANewTab', { iconOpenLink })
  },
  methods: {
    trackGAHelpCenter() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Header > Help')
    },
  },
}
</script>
